import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      id="cta"
      data-testid="section-cta"
      className="bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-12 md:py-16">
        <div
          className="relative overflow-hidden rounded-3xl bg-black text-white p-10 md:p-20"
          data-reveal-zoom
        >
          <div className="noise" aria-hidden />
          <div
            className="absolute inset-0 opacity-[0.06] pointer-events-none"
            style={{
              backgroundImage:
                "linear-gradient(to right, rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,1) 1px, transparent 1px)",
              backgroundSize: "64px 64px",
            }}
            aria-hidden
          />
          <div className="relative grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
            <div className="md:col-span-8">
              <div className="text-xs uppercase tracking-[0.22em] text-white/60 mb-6">
                Get covered today
              </div>
              <h2 className="font-display text-5xl md:text-7xl lg:text-8xl font-semibold tracking-[-0.04em] leading-[0.95]">
                Coverage that
                <br />
                <span className="italic font-medium">actually fits.</span>
              </h2>
            </div>
            <div className="md:col-span-4 flex md:justify-end">
              <Link
                to="/quote"
                data-testid="cta-start-quote-btn"
                className="inline-flex items-center gap-3 bg-white text-black px-8 py-5 rounded-full text-sm font-medium tracking-wide hover:scale-[1.02] active:scale-[0.98] transition-transform"
              >
                Start Your Quote
                <ArrowUpRight size={18} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
